import React, { useCallback, useState } from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import Tooltip from '@wetransfer/transfer/component/tooltip';
import Helper from '@wetransfer/transfer/helper';
import { trackAmplitudeEvent } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';
import Browser from '@wetransfer/transfer/modules/concorde-browser';
import I18n from '@wetransfer/transfer/modules/i18n';

import TeamListAvatarStack from './TeamListAvatarStack';
import styles from './TransferListTeamsContainer.module.scss';

const TransferListTeamsContainer = (): JSX.Element => {
  const [isHover, setisHover] = useState(false);
  const manageTeamUrl = Helper.getManageTeamUrl();

  const toggleClassOnHover = () => {
    setisHover(!isHover);
  };

  const amplitudeTracking = useCallback(() => {
    trackAmplitudeEvent({
      action: 'Manage Workspace Clicked',
      additionalProperties: {
        Context: 'Transfer List',
      },
    });
  }, []);

  return (
    <div
      className={
        Browser.isMobile ? styles.ListContainerMobile : styles.ListContainer
      }
      data-testid="TransferListTeamsContainer"
    >
      <div className={styles.ListContainerActions}>
        <div className={styles.ListContainerAvatarContainer}>
          <TeamListAvatarStack />
        </div>
        <div className={styles.ListContainerAddUserContainer}>
          <Tooltip
            disableTextWrap={true}
            className={styles.ListContainerActionsTooltip}
            trigger={!Browser.isMobile && 'hover'}
            anchor="right"
            offset={16}
            content={I18n.t('page.workspace_bar.tooltip_text')}
          >
            <a
              className={styles.ListContainerAddUser}
              href={manageTeamUrl}
              onMouseEnter={toggleClassOnHover}
              onMouseLeave={toggleClassOnHover}
              onClick={amplitudeTracking}
            >
              <Icon
                data-testid="addUserIcon"
                className={styles.ListContainerAddUserIcon}
                type="AddUser"
                height={14}
                width={14}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default TransferListTeamsContainer;
